import { SimpleDialogWrapper } from "@components/dialog/Dialog.styles";
import { handleDialogKeyDown, setupKeysAfterDialogOpen } from "@components/dialog/dialog.utils";
import { doesElementContainsElement, getFocusableElements } from "@utils/general";
import { PortalRootElementProvider } from "contexts/portalRootElement/PortalRootElementProvider";
import React, { AnimationEvent, AnimationEventHandler, EventHandler } from "react";
import { withTranslation } from "react-i18next";

import ModalBackdrop from "./ModalBackdrop";


interface IProps {
    onClose: () => void;
    onConfirm: () => void;
}

interface IState {
    isClosing: boolean;
}

class SimpleDialog extends React.PureComponent<IProps, IState> {
    _lastActiveElement: HTMLElement;
    _dialogRef = React.createRef<HTMLDivElement>();

    state = {
        isClosing: false
    }

    componentDidMount(): void {
        this.onAfterOpen();
    }

    onAfterOpen = () => {
        this._lastActiveElement = document.activeElement as HTMLElement;
        setupKeysAfterDialogOpen({ ref: this._dialogRef.current });
    };

    componentWillUnmount() {
        this.onAfterClose();
    }

    onAfterClose = () => {
        this._lastActiveElement?.focus();
    };

    handleKeyDown = (event: React.KeyboardEvent) => {
        handleDialogKeyDown(event, { ref: this._dialogRef.current });
    };

    handleAnimationEnd = () => {
        if (this.state.isClosing) {
            this.props.onClose?.();
        }
    }

    handleClose = () => {
        this.setState({ isClosing: true });
    }

    render() {
        /*tabindex with positive value is used to prevent focus from getting out of the dialog*/
        /*with tabindex 0, user could tab from browser URL bar into page DOM, outside of the dialog*/
        const passProps = {
            role: "dialog",
            "aria-modal": true,
            tabIndex: 1
        };

        return (
            <ModalBackdrop isBlurred
                           useAnimation
                           isClosing={this.state.isClosing}
                           closeOnClick
                           onKeyDown={this.handleKeyDown}
                           onAnimationEnd={this.handleAnimationEnd}
                           onClose={this.handleClose}>
                <PortalRootElementProvider useGlobalRoot>
                    <SimpleDialogWrapper ref={this._dialogRef} {...passProps}
                                         $isClosing={this.state.isClosing}>
                        {this.props.children}
                    </SimpleDialogWrapper>
                </PortalRootElementProvider>
            </ModalBackdrop>
        );
    }
}

export default (withTranslation(["Common"])(SimpleDialog));